export default __webpack_public_path__ + "media/images/ongletwhite-leftsmall-74a1a1920d392c673d89cb8ac824ada8.png";